export const authKeys = {
  user: () => ['auth', 'user'] as const,
  address: () => ['auth', 'address'] as const,
  bankAccount: () => ['auth', 'bankAccount'] as const,
}
